export default __webpack_public_path__ + "static/media/TaxExemptionConfirmation.3a4730b1.png";